export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/RU-75e6e2c9778162a51f2e7dea5b3d053b.png";